import { api } from "@";

import { searchValuesPayload } from "./helpers";

// Fetch a paginated list of abandoned carts based on search criteria
export const getCarts = (page = 1, pageSize = "", search) => {
  return api.post(
    `/api/adminCart/carts/abandoned`,
    searchValuesPayload({ ...search, page, pageSize }),
  );
};

// Fetch details of a specific abandoned cart by its ID
export const getCart = (id) =>
  api.get(`/api/adminCart/carts/${id}/abandoned-items`);
